import { useState } from 'react';
import { Navigation, MapPin } from 'lucide-react';
import { MAINT, maintOf, isOverdue } from '../lib/maint';
import { orderStops, routeLegs, routeLink } from '../lib/route';

const stateOf = (f) => (f.type === 'leak' ? 'defect' : maintOf(f));

// network objects (fittings, leaks) selectable for the day route
export default function RouteObjects({ t, project, start }) {
  const objs = project.fittings.filter((f) => f.lat != null);
  const [sel, setSel] = useState([]);
  if (!objs.length) return null;
  const pickBy = (fn) => setSel(objs.filter(fn).map((f) => f.id));
  const toggle = (id) => setSel((s) => (s.includes(id) ? s.filter((x) => x !== id) : [...s, id]));
  const chosen = objs.filter((f) => sel.includes(f.id)).map((f) => ({ ...f, title: f.name }));
  const legs = start && chosen.length ? routeLegs(start, orderStops(start, chosen)) : [];
  return (
    <div className="route-objs" data-testid="route-objects">
      <b>{t.roTitle}</b>
      <div className="ro-quick">
        <button className="chip" data-testid="route-pick-defect" onClick={() => pickBy((f) => stateOf(f) === 'defect')}>🔴 {t.roPickRed}</button>
        <button className="chip" data-testid="route-pick-warn" onClick={() => pickBy((f) => stateOf(f) === 'warn')}>🟡 {t.roPickWarn}</button>
        <button className="chip" data-testid="route-pick-due" onClick={() => pickBy(isOverdue)}>📅 {t.roPickDue}</button>
        <button className="chip" data-testid="route-pick-all" onClick={() => setSel(sel.length === objs.length ? [] : objs.map((f) => f.id))}>☑️ {t.roPickAll}</button>
      </div>
      <ul className="ro-list" data-testid="route-object-list">
        {objs.map((f, i) => {
          const st = stateOf(f);
          return (
            <li key={f.id}>
              <label>
                <input type="checkbox" data-testid={`route-obj-check-${i}`} checked={sel.includes(f.id)} onChange={() => toggle(f.id)} />
                <i style={{ background: MAINT[st] || '#94a3b8' }} />
                <span><b>{f.name}</b><small>{t['fit_' + f.type]} · {f.type === 'leak' ? t.fit_leak : t['mt_' + st]}{isOverdue(f) ? ` · ${t.mt_due}` : ''}</small></span>
              </label>
              <a className="btn btn-outline btn-sm" data-testid={`route-obj-maps-${i}`} href={routeLink(f)} target="_blank" rel="noreferrer"><MapPin size={13} /> Maps</a>
            </li>
          );
        })}
      </ul>
      {legs.map((leg, li) => (
        <a key={li} className="btn btn-green" data-testid={`route-objects-start-${li}`} href={leg.url} target="_blank" rel="noreferrer"><Navigation size={16} /> {t.roStart}{legs.length > 1 ? ` ${li + 1}/${legs.length}` : ''} ({leg.stops.length})</a>
      ))}
    </div>
  );
}
